import Tag from 'antd/lib/tag';

import { IconCalendar, IconMapPin } from '@tabler/icons-react';

import styles from './render-events.module.css';

export default function RenderEvents({ events, handleEventClick }) {
      return (
        <div className={styles.threatsGrid}>
          {events.map((event) => (
            <div 
              key={event.id} 
              className={`${styles.threatCard} ${styles.clickable}`}
              onClick={() => handleEventClick(event)}
            >
              <div className={styles.threatHeader}>
                <span className={styles.threatType}>{event.weatherPrimary}</span>
                <span className={styles.threatDuration}>{event.hours} hours</span>
              </div>
              <div className={styles.threatDetails}>
                <div className={styles.threatTime}>
                  <IconCalendar size={16} className={styles.threatIcon} />
                  <div className={styles.threatTimeRange}>
                    <div>Start: {event.formattedStartDate}</div>
                    <div>End: {event.formattedEndDate}</div>
                  </div>
                </div>
                <div className={styles.threatLocation}>
                  <IconMapPin size={16} className={styles.threatIcon} />
                  <span>{event.siteAddress}</span>
                </div>
                {event.ongoing && (
                  <Tag color="error" style={{ alignSelf: 'flex-start' }}>
                    Ongoing
                  </Tag>
                )}
              </div>
            </div>
          ))}
        </div>
      );
}